import type { Condition } from "@skilitics/judy";

import type { GetTriggerEvents } from "./getTriggerEvents.ts";

export const buildTriggerWhereConditionCreate =
  (getTriggerEvents: GetTriggerEvents) =>
  (nodeId: number, eventType: string, config: Record<string, unknown>): Condition | undefined => {
    const events = getTriggerEvents(nodeId);
    const eventDef = events.find((e) => e.type === eventType);
    return eventDef?.whereConditionBuilder?.build(config, { payloadProperty });
  };

export type BuildTriggerWhereCondition = ReturnType<typeof buildTriggerWhereConditionCreate>;

const payloadProperty = <T extends "boolean" | "string" | "number">(name: string, type: T) => ({
  type,
  resolveType: "eventPayloadProperty" as const,
  name,
});
